
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("b0ztm", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "GlobalAutomationApp", () => $0caf38752f024d14$export$7467b029cb2c9926);
$parcel$export(module.exports, "default", () => $0caf38752f024d14$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
parcelRequire("c4xqm");

var $drk9v = parcelRequire("drk9v");

var $9NiTW = parcelRequire("9NiTW");

var $4dRjY = parcelRequire("4dRjY");
function $0caf38752f024d14$export$7467b029cb2c9926(_props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4dRjY.MarkProductStart), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9NiTW.AuthenticationCheck), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $drk9v.default), null)));
}
var $0caf38752f024d14$export$2e2bcd8739ae039 = $0caf38752f024d14$export$7467b029cb2c9926;

});
parcelRegister("drk9v", function(module, exports) {

$parcel$export(module.exports, "default", () => $c8c7e8d35da359c5$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $1WqFo = parcelRequire("1WqFo");

var $co1wz = parcelRequire("co1wz");

var $4R6GH = parcelRequire("4R6GH");

var $9FUIO = parcelRequire("9FUIO");

var $8zOmE = parcelRequire("8zOmE");
var $95EVP = parcelRequire("95EVP");

var $dZw8H = parcelRequire("dZw8H");

var $2tT7R = parcelRequire("2tT7R");

var $9OXo1 = parcelRequire("9OXo1");

var $7FRCI = parcelRequire("7FRCI");

var $fkREl = parcelRequire("fkREl");
const $c8c7e8d35da359c5$var$BOOTSTRAP_FILENAME = 'automationManagerBootstrap.pack.js';
let $c8c7e8d35da359c5$var$isBootStrapBeenAppended = false;
const $c8c7e8d35da359c5$export$1d6aa6cfe656cb32 = (jiraEnvironment, isAutomationDevInstance)=>{
    if (isAutomationDevInstance) {
        if (jiraEnvironment === 'staging') return 'dev';
        if (jiraEnvironment === 'prod') return 'test';
    }
    return jiraEnvironment === 'staging' ? 'staging' : 'prod';
};
/**
 * https://developer.atlassian.com/platform/bifrost/config/custom-domain/#custom-domain:-stating-your-own-identity
 * For fedramp, we return **environment type** rather than the **environment** itself.
 * @param environment
 * @param isFedRampInstance
 * @returns
 */ const $c8c7e8d35da359c5$var$getBifrostEnvironment = (environment, isFedRampInstance = false)=>{
    let bifrostEnvironment;
    if (environment === 'staging') bifrostEnvironment = isFedRampInstance ? 'stg' : 'stg-east';
    else // it's empty for fedramp prod
    bifrostEnvironment = isFedRampInstance ? '' : 'prod-east';
    return bifrostEnvironment;
};
/**
 * Gets the correct Bifrost url suffix based on the perimeter
 */ const $c8c7e8d35da359c5$var$getBifrostUrlSuffix = (isFedRampInstance)=>isFedRampInstance ? 'frontend.cdn.atlassian-us-gov-mod.com' : 'frontend.public.atl-paas.net';
const $c8c7e8d35da359c5$var$generateBifrostBootstrapUrl = (env, buildNumber)=>{
    const isFedRampInstance = (0, $1WqFo.isFedRamp)();
    const bifrostUrlPrefix = 'https://automation-frontend';
    const bifrostEnvironment = $c8c7e8d35da359c5$var$getBifrostEnvironment(env, isFedRampInstance);
    const bifrostUrlSuffix = $c8c7e8d35da359c5$var$getBifrostUrlSuffix(isFedRampInstance);
    const bifrostBaseUrl = [
        bifrostUrlPrefix,
        bifrostEnvironment,
        bifrostUrlSuffix
    ]// remove empty strings
    .filter((str)=>str).join('.');
    const bifrostUrl = [
        bifrostBaseUrl,
        'assets',
        buildNumber,
        'bootstrap',
        $c8c7e8d35da359c5$var$BOOTSTRAP_FILENAME
    ].join('/');
    return bifrostUrl;
};
const $c8c7e8d35da359c5$export$d08bde130a2fd8bc = (env, buildNumber)=>{
    // Local dev source
    if (env === 'dev') return `https://localhost:8082/${$c8c7e8d35da359c5$var$BOOTSTRAP_FILENAME}`;
    return $c8c7e8d35da359c5$var$generateBifrostBootstrapUrl(env, buildNumber);
};
const $c8c7e8d35da359c5$var$AutomationAppStackContextLoader = ({ container: container })=>{
    const { activationId: activationId, cloudId: cloudId } = (0, $9OXo1.useTenantContext)();
    const isAutomationDevInstance = (0, $co1wz.ff)('automation-dev-helper');
    const jiraEnvironment = (0, $2tT7R.useEnvironment)();
    const automationEnvironment = $c8c7e8d35da359c5$export$1d6aa6cfe656cb32(jiraEnvironment, isAutomationDevInstance);
    const stackContext = (0, $fkREl.default)(cloudId, automationEnvironment);
    if (stackContext.status === 'loading') // TODO: consider a better loading state, it's non-trivial as our bootstrap script also adds a loader and deletes it
    return null;
    if (stackContext.status === 'error') return(// TODO: i18n and analytics
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7FRCI.default), {
        title: "Failed to load Automation",
        description: stackContext.error
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c8c7e8d35da359c5$var$AutomationAppBody, {
        automationEnvironment: automationEnvironment,
        activationId: activationId,
        cloudId: cloudId,
        stackContext: stackContext.value,
        container: container
    });
};
const $c8c7e8d35da359c5$var$BOOTSTRAP_ERROR_MESSAGE = 'Sorry, something went wrong loading Automation. Please try again.';
const $c8c7e8d35da359c5$var$DEV_BOOTSTRAP_ERROR_MESSAGE = 'Are you running devWatch?';
const $c8c7e8d35da359c5$var$AutomationAppBody = ({ automationEnvironment: automationEnvironment, activationId: activationId, cloudId: cloudId, stackContext: stackContext, container: container })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $95EVP.useAnalyticsEvents)();
    const [bootStrapError, setBootStrapError] = (0, $5uXOq.useState)(null);
    (0, $5uXOq.useEffect)(()=>{
        if (!$c8c7e8d35da359c5$var$isBootStrapBeenAppended) {
            // eslint-disable-next-line jira/js/no-document-script, jira/jira-ssr/no-unchecked-globals-usage
            const script = document.createElement('script');
            const src = $c8c7e8d35da359c5$export$d08bde130a2fd8bc(automationEnvironment, stackContext.buildNumber);
            const startTime = performance.now();
            script.src = src;
            script.async = true;
            script.onload = ()=>{
                const duration = performance.now() - startTime;
                (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({
                    actionSubject: 'automationJiraEntry',
                    action: 'loaded'
                }), 'automationBootstrapFile loaded', {
                    duration: duration,
                    automationEnvironment: automationEnvironment
                });
            };
            script.onerror = async ()=>{
                const duration = performance.now() - startTime;
                (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({
                    actionSubject: 'automationJiraEntry',
                    action: 'failed'
                }), 'automationBootstrapFile failed', {
                    duration: duration,
                    automationEnvironment: automationEnvironment
                });
                setBootStrapError(automationEnvironment === 'dev' ? $c8c7e8d35da359c5$var$DEV_BOOTSTRAP_ERROR_MESSAGE : $c8c7e8d35da359c5$var$BOOTSTRAP_ERROR_MESSAGE);
                throw new Error(`Failed to load automation boostrap for env ${automationEnvironment}, src was '${src}'`);
            };
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            document.body?.appendChild(script);
            $c8c7e8d35da359c5$var$isBootStrapBeenAppended = true;
        }
    }, [
        automationEnvironment,
        createAnalyticsEvent,
        stackContext.buildNumber
    ]);
    // Lifecycle events automation application can respond to start the application, and destroy it.
    (0, $5uXOq.useEffect)(()=>{
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.postMessage('automation-container-mounted');
        return ()=>{
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.postMessage('automation-container-unmounted');
        };
    }, []);
    if (bootStrapError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7FRCI.default), {
        title: "Failed to load Automation",
        description: bootStrapError
    });
    const context = {
        activationId: activationId,
        cloudId: cloudId,
        scopeId: container?.id || 'GLOBAL',
        scopeKey: container?.key,
        scopeType: container?.type,
        productType: 'jira',
        env: automationEnvironment,
        staticPrefix: stackContext.staticPrefix,
        perimeter: stackContext.perimeter
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9FUIO.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        id: "automation-container",
        "data-context": JSON.stringify(context),
        "data-testid": "automation.automation-app-container"
    }), (0, $4R6GH.fg)('jsm_simplified_project_settings_navigation') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dZw8H.SpaStatePageReady), null));
};
const $c8c7e8d35da359c5$var$AutomationApp = ({ container: container })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c8c7e8d35da359c5$var$AutomationAppStackContextLoader, {
        container: container
    });
var $c8c7e8d35da359c5$export$2e2bcd8739ae039 = $c8c7e8d35da359c5$var$AutomationApp;

});
parcelRegister("9FUIO", function(module, exports) {

$parcel$export(module.exports, "default", () => $1259b4dcb355d8f8$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $39xOx = parcelRequire("39xOx");

var $lfTZh = parcelRequire("lfTZh");

var $hPtZI = parcelRequire("hPtZI");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $1259b4dcb355d8f8$var$OpenHelpPanelLinkThroughEventListener = (0, $hPtZI.lazy)(()=>(parcelRequire("2ixZF")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/help-panel-button/src/services/open-help-panel-link-through-event-listener/index.tsx"
});
const $1259b4dcb355d8f8$export$9b28d5c0f56030a7 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $39xOx.JSErrorBoundary), {
        id: "open-help-panel-link-through-event-listener",
        packageName: "jira-help-panel-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "async-open-help-panel-link-through-event-listener",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1259b4dcb355d8f8$var$OpenHelpPanelLinkThroughEventListener, null)));
var $1259b4dcb355d8f8$export$2e2bcd8739ae039 = $1259b4dcb355d8f8$export$9b28d5c0f56030a7;

});
parcelRegister("2ixZF", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = Promise.all([
    $6fhBS("eNmuD"),
    $6fhBS("h2MrD"),
    $6fhBS("bYT2S"),
    $6fhBS("cM9em"),
    $6fhBS("fr9NE"),
    $6fhBS("li0NF")
]).then(()=>parcelRequire('LS48m'));

});


parcelRegister("7FRCI", function(module, exports) {

$parcel$export(module.exports, "default", () => $e338e454c92b953e$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $6T4rd = parcelRequire("6T4rd");
var $jJ1Sb = parcelRequire("jJ1Sb");

var $dvl5H = parcelRequire("dvl5H");
const $e338e454c92b953e$var$BootstrapPage = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6T4rd.default), {
        xcss: $e338e454c92b953e$var$pageContainerStyles,
        testId: "automation.automation-platform-bootstrap-error"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6T4rd.default), {
        xcss: $e338e454c92b953e$var$contentContainerStyles
    }, props.children));
const $e338e454c92b953e$var$BootstrapError = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e338e454c92b953e$var$BootstrapPage, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dvl5H.default), {
        appearance: "error",
        title: props.title
    }, props.description));
var $e338e454c92b953e$export$2e2bcd8739ae039 = $e338e454c92b953e$var$BootstrapError;
const $e338e454c92b953e$var$pageContainerStyles = (0, $jJ1Sb.xcss)({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '80vh'
});
const $e338e454c92b953e$var$contentContainerStyles = (0, $jJ1Sb.xcss)({
    justifyContent: 'center',
    width: '500px'
});

});

parcelRegister("fkREl", function(module, exports) {

$parcel$export(module.exports, "default", () => $572b5e2beda00d24$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8JCZd = parcelRequire("8JCZd");
/**
 * dev and test don't have the best solutions.
 * test - on the first pass, it actually gets prod since the persistedStackId will be undefined.
 *        it then reaches the prod bootstrap logic which sets the testStackId and reloads
 * dev - it shouldn't come here, it will go to localhost first. this means the fallback is not yet supported.
 * @param bootstrapEnv
 * @returns
 */ const $572b5e2beda00d24$var$getApiPath = (bootstrapEnv)=>{
    if (bootstrapEnv === 'staging') return 'staging';
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const persistedTestStackId = window.sessionStorage.getItem('AUTOMATION_TEST_STACK_ID');
    if (bootstrapEnv === 'test' && typeof persistedTestStackId === 'string') return persistedTestStackId;
    return 'pro';
};
const $572b5e2beda00d24$var$getStackContextUrl = (cloudId, bootstrapEnv)=>`/gateway/api/automation/internal-api/jira/${cloudId}/${$572b5e2beda00d24$var$getApiPath(bootstrapEnv)}/rest/stackcontext`;
const $572b5e2beda00d24$var$DEV_STACK_CONTEXT = {
    // buildNumber is not actually used in dev since we don't redirect to bifrost, we serve from localhost
    buildNumber: 'automation-dev',
    staticPrefix: 'https://localhost:8088',
    perimeter: 'COMMERCIAL'
};
const $572b5e2beda00d24$var$useStackContext = (cloudId, bootstrapEnv)=>{
    const [stackContextResult, setStackContextResult] = (0, $5uXOq.useState)({
        status: 'loading',
        value: null,
        error: null
    });
    (0, $5uXOq.useEffect)(()=>{
        const abortController = new AbortController();
        const fetchStackContext = async ()=>{
            try {
                const response = await fetch($572b5e2beda00d24$var$getStackContextUrl(cloudId, bootstrapEnv), {
                    signal: abortController.signal
                });
                const data = await response.json();
                if (!(0, $8JCZd.isObjectStackContext)(data)) throw new Error('Something went wrong loading Automation');
                setStackContextResult({
                    status: 'success',
                    value: data,
                    error: null
                });
            } catch (e) {
                if (e instanceof Error) {
                    // no need to set error if it was aborted due to clean up
                    if (e.name === 'AbortError') return;
                    setStackContextResult({
                        status: 'error',
                        value: null,
                        error: e.message
                    });
                } else setStackContextResult({
                    status: 'error',
                    value: null,
                    error: String(e)
                });
            }
        };
        if (bootstrapEnv !== 'dev') fetchStackContext();
        return ()=>{
            abortController.abort();
        };
    }, [
        cloudId,
        bootstrapEnv
    ]);
    if (bootstrapEnv === 'dev') return {
        status: 'success',
        error: null,
        value: $572b5e2beda00d24$var$DEV_STACK_CONTEXT
    };
    return stackContextResult;
};
var $572b5e2beda00d24$export$2e2bcd8739ae039 = $572b5e2beda00d24$var$useStackContext;

});
parcelRegister("8JCZd", function(module, exports) {

$parcel$export(module.exports, "isObjectStackContext", () => $3613c469ecd988e9$export$f2c8b2575b518327);
const $3613c469ecd988e9$var$SUPPORTED_PERIMETERS = [
    'COMMERCIAL',
    'FEDRAMP'
];
const $3613c469ecd988e9$export$f2c8b2575b518327 = (value)=>{
    if (typeof value !== 'object' || value === null) return false;
    // ignore @typescript-eslint/consistent-type-assertions because we are checking the type of the object
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const potentialStackContext = value;
    return typeof potentialStackContext.staticPrefix === 'string' && typeof potentialStackContext.buildNumber === 'string' && $3613c469ecd988e9$var$SUPPORTED_PERIMETERS.includes(potentialStackContext.perimeter);
};

});



parcelRegister("4dRjY", function(module, exports) {

$parcel$export(module.exports, "PRODUCT_START_MARK", () => $9953c23a4f71adac$export$8e54fca0a680fdfd);
$parcel$export(module.exports, "MarkProductStart", () => $9953c23a4f71adac$export$2a999c5f84501025);

var $x9xyg = parcelRequire("x9xyg");
const $9953c23a4f71adac$export$8e54fca0a680fdfd = 'PRODUCT_START';
const $9953c23a4f71adac$export$2a999c5f84501025 = ()=>{
    if (!false) {
        performance.clearMarks($9953c23a4f71adac$export$8e54fca0a680fdfd);
        (0, $x9xyg.setMark)($9953c23a4f71adac$export$8e54fca0a680fdfd);
    }
    return null;
};

});



//# sourceMappingURL=async-global-automation.678220a9.js.map
